import { TRAVELINFO, FAQS } from '../data/site';
import { useSite } from '../data/SiteContext';

export default function TravelInfo() {
  const { contact } = useSite();
  return (
    <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
      <div className="kicker">Travel Info</div>
      <h1 className="page-h1">The practical stuff, answered.</h1>
      <p className="page-sub">Everything between booking and boarding — in plain language.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:18 }}>
        {TRAVELINFO.map(t => (
          <div key={t.title} className="card-cool" style={{ cursor:'pointer', padding:24, borderRadius:20, boxShadow:'0 8px 22px rgba(16,90,90,0.08)' }}>
            <div className="serif" style={{ fontSize:21, marginBottom:8 }}>{t.title}</div>
            <div style={{ fontSize:14.5, lineHeight:1.6, color:'#5a726f' }}>{t.text}</div>
          </div>
        ))}
      </div>
      <div style={{ marginTop:56 }}>
        <div className="kicker">FAQ</div>
        <h2 className="serif" style={{ fontSize:'clamp(28px,4vw,42px)', margin:'8px 0 24px', letterSpacing:'-0.5px' }}>Frequently asked questions</h2>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(320px,1fr))', gap:16 }}>
          {FAQS.map(f => (
            <div key={f.q} className="card-cool" style={{ padding:24, borderRadius:20, boxShadow:'0 8px 22px rgba(16,90,90,0.08)' }}>
              <div style={{ display:'flex', gap:12, alignItems:'flex-start', marginBottom:8 }}>
                <span style={{ flexShrink:0, width:24, height:24, borderRadius:'50%', background:'#ffdd55', color:'#0c2b2f', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:13 }}>?</span>
                <div style={{ fontWeight:800, fontSize:16.5, lineHeight:1.35 }}>{f.q}</div>
              </div>
              <div style={{ fontSize:14.5, lineHeight:1.65, color:'#5a726f', paddingLeft:36 }}>{f.a}</div>
            </div>
          ))}
        </div>
        <div style={{ marginTop:28, display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, flexWrap:'wrap', padding:'26px 30px', borderRadius:22, background:'#0c2b2f', color:'#fff' }}>
          <div style={{ fontSize:17, fontWeight:700 }}>Still have a question? We answer in minutes, not days.</div>
          <a href={contact.waLink} target="_blank" rel="noreferrer" className="btn btn-yellow" style={{ whiteSpace:'nowrap' }}>Ask us on WhatsApp</a>
        </div>
      </div>
    </div>
  );
}
